import { createContext } from 'react';
export const TranslationContext = createContext({
	lang: 'fr',
	setLang: (lang: string) => {},
});
